import React from "react";
import Homepage from "./Homepage";
import Ispirazione from "./Ispirazione";
import Finitura from "./Finitura";
import ColoriFormati from "./ColoriFormati";
import Collezione from "./Collezione";
import Dettagli from "./Dettagli";
import Scaglie from "./Scaglie";
import ScaglieDx from "./ScaglieDx";
import Gallery from "./Gallery";
import Footer from "./Footer";
import { Provider } from "react-redux";
import { store } from "./app/store";
import Cta from "./Cta";
import FormPage from "./FormPage";
import EfficientCursor from "react-efficient-cursor";
import cursorWrap from "./images/cursor/cursorWrapper.svg";
import cursorPoint from "./images/cursor/cursorPoint.svg";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import styles from './App.module.sass'
import { appConfig } from './configuration'
import { useMediaQuery } from "@material-ui/core";
import StaticRenderer from './StaticRenderer';


export default function App() {
  const isMobile = useMediaQuery('(max-width: 760px)');
  const isRenderRoute = window.location.pathname.endsWith('/render-static');

  if (isRenderRoute) {
    return <StaticRenderer />;
  }
  return (
    <div className="app" style={{ cursor: "none !important" }}>
      <Provider store={store}>
        <div className={styles.bg}>
          <img
            src={isMobile ? appConfig.bgMobile : appConfig.bgDesktop}
            alt="background"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div className={styles.body}>
          <Homepage />
          <Ispirazione />
            <Dettagli />
            <ScaglieDx />
          <Gallery />
            <Scaglie />
          <ColoriFormati />
          <Collezione />
        </div>
      </Provider>
    </div>
  );
}
